<template>
  <b-modal
    id="create-equipment-report-modal"
    title="Equipment Report Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Equipment Report Create</h2>
    </template>
    <validation-observer ref="siteCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">

        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="expiry_date">
          <template #label>
            Expiry Date <span class="text-danger">*</span>
          </template>
          <b-form-datepicker id="expiry_date" v-model="expiry_date" class="mb-2"></b-form-datepicker>          
        </b-form-group>

        
        <b-form-group
          class="form-group"
          id="input-group-2"
          label="ESMR:"
          label-for="input-2"
          description="Upload a PDF file."
        >
          <b-form-file
            id="observationReport"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            required
            accept=".pdf"
            plain
            v-model="esmr"
          ></b-form-file>

        </b-form-group>
        

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      regex: /^[a-zA-Z ]*$/,
      sites: [],
      site: "",
      expiry_date: "",
      esmr: null,
    };
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      createEquipmentReport: "appData/createEquipmentReport",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("site", this.site.id);
        formData.append("expiry_date", this.expiry_date);
        if (this.esmr){
          formData.append("esmr", this.esmr);
        }
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createEquipmentReport(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Equipment Report Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-equipment-report-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    reset() {
      this.site = "";
      this.expiry_date = null;
      this.esmr = null;
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
};
</script>

<style></style>
